import { GetTransitionOptions } from '@optimus-web/common';
import { TransitionState } from '@optimus-web/helpers';

export interface TransitionProps extends GetTransitionOptions {
    transitionState?: TransitionState;
    duration?: number;
}

export enum TransitionName {
    FadeIn = 'FadeIn',
    FadeInDelayed = 'FadeInDelayed',
    SlideInFromLeft = 'SlideInFromLeft',
    SlideInFromRight = 'SlideInFromRight',
}
